import * as actions from './filtro.action'
import inicialState from './filtro.state'

const filtrosReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.DROPDOWN_OPEN:
      return {
        ...state,
        dropdownOpen: action.payload.dropdownOpen
      }
    case actions.DROPDOWN_OPEN_FAVORITOS:
      return {
        ...state,
        dropdownOpenFavoritos: action.payload.dropdownOpenFavoritos
      }
    case actions.DROPDOWN_OPEN_ORDENACAO:
      return {
        ...state,
        dropdownOpenOrdenacao: action.payload.dropdownOpenOrdenacao
      }
    case actions.INPUT_VAZIO:
      return {
        ...state,
        inputVazio: action.payload.inputVazio
      }
    case actions.LABEL_FILTRO_SELECIONADO:
      return {
        ...state,
        labelFiltroSelecionado: action.payload.labelFiltroSelecionado
      }
    case actions.LABEL_FILTRO_STATUS_SELECIONADO:
      return {
        ...state,
        labelFiltroStatusSelecionado:
          action.payload.labelFiltroStatusSelecionado
      }
    case actions.ID_FILTRO_SELECIONADO:
      return {
        ...state,
        idFiltroSelecionado: action.payload.idFiltroSelecionado
      }
    case actions.TIPO_FILTRO_SELECIONADO:
      return {
        ...state,
        tipoFiltroSelecionado: action.payload.tipoFiltroSelecionado
      }
    case actions.OPTIONS_FILTRO_INPUT_TYPE_SELECT:
      return {
        ...state,
        optionsFiltroInputTypeSelect:
          action.payload.optionsFiltroInputTypeSelect
      }
    case actions.LABEL_FAVORITO_SELECIONADO:
      return {
        ...state,
        labelFavoritoSelecionado: action.payload.labelFavoritoSelecionado
      }
    case actions.LABEL_ORDENACAO_SELECIONADO:
      return {
        ...state,
        labelOrdenacaoSelecionado: action.payload.labelOrdenacaoSelecionado
      }

    case actions.TITULO_NOVO_FILTRO_FAVORITO:
      return {
        ...state,
        tituloNovoFiltroFavorito: action.payload.tituloNovoFiltroFavorito
      }
    case actions.NOVO_FILTRO_FAVORITO_IS_DEFAULT:
      return {
        ...state,
        novoFiltroFavoritoIsDefault: action.payload.novoFiltroFavoritoIsDefault
      }
    case actions.SHOW_MODAL_FAVORITO:
      return {
        ...state,
        showModalFavoritos: action.payload.showModalFavoritos
      }
    case actions.VALOR_FILTRO:
      return {
        ...state,
        valorFiltro: action.payload.valorFiltro
      }
    case actions.ETAPA_FILTRO:
      return {
        ...state,
        etapaFiltro: action.payload.etapaFiltro
      }
    case actions.FILTROS:
      return {
        ...state,
        filtros: action.payload.filtros
      }
    case actions.FAVORITOS:
      return {
        ...state,
        favoritos: action.payload.favoritos
      }
    case actions.FILTROS_SELECIONADOS:
      return {
        ...state,
        filtrosSelecionados: action.payload.filtrosSelecionados
      }
    case actions.PERIODO_DE:
      return {
        ...state,
        periodoDe: action.payload.periodoDe
      }
    case actions.PERIODO_ATE:
      return {
        ...state,
        periodoAte: action.payload.periodoAte
      }

    case actions.ORDENACAO:
      return {
        ...state,
        ordenacao: action.payload.ordenacao
      }

    case actions.SENTIDO_ORDENACAO_ASC:
      return {
        ...state,
        sentidoOrdenacaoASC: action.payload.sentidoOrdenacaoASC
      }

    case actions.DROPDOWN_OPEN_GRUPO_USUARIO:
      return {
        ...state,
        dropdownOpenGrupoUsuario: action.payload.dropdownOpenGrupoUsuario
      }

    case actions.GRUPO_USUARIOS:
      return {
        ...state,
        grupoUsuarios: action.payload.grupoUsuarios
      }

    case actions.LABEL_GRUPOS_USUARIOS:
      return {
        ...state,
        labelGruposUsuario: action.payload.labelGruposUsuario
      }
    case actions.ID_GRUPO_USUARIOS:
      return {
        ...state,
        idGrupoUsuario: action.payload.idGrupoUsuario
      }
    case actions.STATUS_ETAPA_SELECIONADA:
      return {
        ...state,
        statusEtapaSelecionada: action.payload.statusEtapaSelecionada
      }
    case actions.DROPDOWN_OPEN_FILTER_LINKED:
      return {
        ...state,
        dropdownOpenFilterLinked: action.payload.dropdownOpenFilterLinked
      }
    case actions.LABEL_FILTER_LINKED:
      return {
        ...state,
        labelFilterLinked: action.payload.labelFilterLinked
      }
      case actions.DATA_NASCIMENTO:
      return {
        ...state,
        dataNascimento: action.payload.dataNascimento
      }
    default:
      return state
  }
}

export default filtrosReducer



// WEBPACK FOOTER //
// ./src/pages/main/filtros/filtro.reducer.js